import React from 'react';
import './App.css';

function Footer() {
  return (
    <footer className="footer">
      {/* Footer content can be added here if needed */}
    </footer>
  );
}

export default Footer;
